<template>
  <div id="ResponsiveCss">{{ ActDescBtn }}
    <table :height="this.windowSize.height - 8" :max-height="this.windowSize.height - 8" style="position: absolute;"
           width="100%">

      <tr height="48px" max-height="48px">
        <ContenidoBase :EstadoBtn="EstadoBtn"
                       :descripcion="'Registrar Notas de Débito a los Proveedores.'" :titulo="'Notas de Débito a los Proveedores.'"
                       @MethodAnular="NotifMessage" @MethodEliminar="NotifMessage" @MethodGuardar="presave"
                       @MethodImprimir="imprimirList" @MethodNuevo="newwnuevo" @MethodVeercuenta="vercuenta"
                       @abrirBarraTablaDinamica="abrirTabla" />
      </tr>

      <tr>
        <!-- BarraPrimaria --------------------------------------------------------------------------------->
        <td v-show="BarraTablaDinamicaAprir" :max-height="this.windowSize.height - 96" width="109">

          <div class="overflow-y-auto "
               v-bind:style="{ 'max-height': this.windowSize.height - 96 + 'px', 'max-width': '325px', 'width': '325px' }">

            <v-tooltip left>
              <template v-slot:activator="{ on }">
                <!--------------------- aqui va la otra tabla izquierda --------->

                <center>
                  <v-btn-toggle>
                    <v-btn color="yellow accent-4" small @click.prevent="actualiza_tb_ver"><i class="fa fa-eye"
                                                                                              style="font-size: 25px;"> </i>
                      ver
                    </v-btn>
                    <v-btn color="teal darken-2" dark small text
                           @click.prevent="dialogFiltros = true, ObjTemTbDinam = JSON.parse(JSON.stringify(Modallfiltro))">
                      <i class="fa fa-search" style="font-size: 25px;"> </i>
                      Filtrar
                    </v-btn>
                  </v-btn-toggle>
                </center>


                <BarraDinamicaLimitePlus :ContListSlot="[{ Text: 'Código', NomValue: 'notadebitoproveedoresPK', Nv2: 'codigo', Ctsl: 2, Type: 0, State: true },
{ Text: 'Nombre', NomValue: 'proveedor', Nv2: 'nombre', Ctsl: 2, Type: 0, State: true },
{ Text: 'Valor $', NomValue: 'valor', Ctsl: 1, Type: 2, State: true },
{ Text: 'Referencia', NomValue: 'referencia', Ctsl: 1, Type: 0, State: true },
{ Text: 'Concepto', NomValue: 'concepto', Ctsl: 1, Type: 0, State: true },
{ Text: 'NCF', NomValue: 'ncf', Ctsl: 1, Type: 0, State: true },
{ Text: 'fecha', NomValue: 'nuevaFecha', Ctsl: 1, Type: 1, State: true },
{ Text: 'Estado', NomValue: 'activa', Ctsl: 1, Type: 0.2, State: true }]" :PropsList="ListItems"
                                         :PropsNombre="'Nota Débito'"
                                         :PropsSeachNombre="'Búsqueda por Código o Referencia'" :TbPaginator="TbPaginator"
                                         :TbTotalItem="TbTotalItem" :headers="[
                    { text: 'Código', value: 'notadebitoproveedoresPK.codigo' },
                    /* { text: 'Nombre', value: 'nombre' },
                     { text: 'Balance', value: 'balancecliente.balance' }*/
                  ]"
                                         PropsSearchNumber @CargarPaginacion="CargarPaginacion" @EmitDAta="datostabla" />
              </template>
            </v-tooltip>


          </div>
        </td>
        <!-- fn BarraPrimaria ---------------------------------------------------------------------------------->
        <!-- contenido central ------------------------------------------------------------------------------ -->
        <td :max-height="this.windowSize.height - 96">
          <v-app id="inspire" class="overflow-y-auto "
                 v-bind:style="{ 'max-height': this.windowSize.height - 96 + 'px' }">
            <div class="px-2">


              <v-card color="grey lighten-3">
                <div class="px-2">

                  <v-form ref="form" v-model="valid" lazy-validation>
                    <input v-model="form.NotaDebito.notadebitoproveedoresPK.codigo" style="display:none;"
                           type="number" />
                    <v-row>
                      <!-- columna 1 ------------------------------>
                      <v-col cols="12" md="3" sm="3">

                        <!------------------------------------------ Documentos -->
                        <v-combobox id="formdisabledInput" v-model="form.NotaDebito.documentoproveedor" :disabled="form.NotaDebito.notadebitoproveedoresPK.codigo > 0" :items="RDocumento" :rules="[$rules.required]"
                                    autocomplete="off" dense
                                    item-text="descripcion" label="* Documentos:"
                                    outlined
                                    @blur="SelctCbDocumento" @focus="cargarDocumento"
                                    v-on:blur="getCrearCont">
                          <template v-slot:prepend>
                            <i class="fa fa-book" style="font-size: 30px;"></i>
                          </template>
                        </v-combobox>


                        <!-- Tipo de gasto --------------------------------------------------->
                        <v-combobox v-model="form.NotaDebito.gasto" :items="RTipoGasto" autocomplete="off" dense item-text="descripcion"
                                    label="Categoría:" outlined required
                                    @blur="SelctCbTipoGasto"
                                    @focus="CargarRTipopago">
                          <template v-slot:prepend>
                            <i class="fa fa-tag" style="font-size: 20px;"></i>
                          </template>
                        </v-combobox>


                        <!------------------------------------------------ ITBIS incluido -->

                        <!-- :rules="[$rules.porciento]" -->
                        <AutoNumeric id="formdisabledInput" v-model.number="form.NotaDebito.itbis" :disabled="form.NotaDebito.notadebitoproveedoresPK.codigo > 0" autocomplete="off"
                                     dense label="ITBIS(informativo):"
                                     outlined>
                          <template v-slot:prepend>
                            <i class="fa fa-usd" style="font-size: 20px;"></i>
                          </template>
                        </AutoNumeric>


                      </v-col>
                      <!-- fn columna 1 ------------------------------>

                      <!-- columna 2 ------------------------------>
                      <v-col cols="12" md="3" sm="3">

                        <!----------------------------------------------  Fecha  -->
                        <v-text-field v-model="form.NotaDebito.fecha" :rules="[$rules.required]" dense label="Fecha " outlined
                                      type="date">

                          <template v-slot:prepend>
                            <i class="fa fa-calendar" style="font-size: 20px;"></i>
                          </template>
                        </v-text-field>


                        <!-- no documento  --------------------------------------------------->
                        <v-text-field v-model="form.NotaDebito.referencia" :maxlength="30" dense label="No. de Documento:" outlined>
                          <template v-slot:prepend>
                            <i class="fa fa-slack" style="font-size: 20px;"></i>
                          </template>
                        </v-text-field>

                        <!-------------------------------------------------- Valor -->
                        <AutoNumeric id="formdisabledInput" v-model.number="form.NotaDebito.valor" :disabled="form.NotaDebito.notadebitoproveedoresPK.codigo > 0" :rules="[$rules.required]"
                                     autocomplete="off"
                                     dense label="* Valor:"
                                     outlined
                                     @blur="BlurSelectAplicaAbonoFact"
                                     v-on:blur="getCrearCont">
                          <template v-slot:prepend>
                            <i class="fa fa-usd" style="font-size: 20px;"></i>
                          </template>
                        </AutoNumeric>

                      </v-col>
                      <!-- columna 2 ------------------------------>

                      <!-- columna 3 ------------------------------>
                      <v-col cols="12" md="3" sm="3">


                        <!--  NCF --------------------------------------------------->
                        <v-text-field v-model="form.NotaDebito.ncf" dense label="NCF:" outlined
                                      @blur="VerificarProveedorNcf">
                          <template v-slot:prepend>
                            <i class="fa fa-barcode" style="font-size: 20px;"></i>
                          </template>
                        </v-text-field>


                        <!-------------------------------------------------- Comentario -->
                        <v-textarea v-model="form.NotaDebito.concepto" :rules="[$rules.required]" autocomplete="off" dense label="* Concepto:"
                                    outlined rows="4"
                                    v-on:blur="getCrearCont">
                          <template v-slot:prepend>
                            <i class="fa fa-commenting" style="font-size: 20px;"></i>
                          </template>
                        </v-textarea>
                      </v-col>
                      <!-- columna 3 ------------------------------>

                      <!-- columna 4 ------------------------------>
                      <v-col cols="12" md="3" sm="3">

                        <!-------------------------------------------------- proveedor -->

                        <v-combobox id="formdisabledInput" v-model="form.NotaDebito.proveedor" :disabled="form.NotaDebito.notadebitoproveedoresPK.codigo > 0" :items="Rproveedor" :rules="[$rules.required]"
                                    autocomplete="off" dense item-text="nombre"
                                    label="* Proveedor:" outlined @blur="SelctCbProveedor"
                                    @change="changeProveedor"
                                    @focus="cargarProveedor" @keyup="CbFilProveedor"
                                    v-on:blur="getCrearCont">
                          <template v-slot:prepend>
                            <i class="fa fa-user-circle" style="font-size: 20px;"></i>
                          </template>
                        </v-combobox>


                        <v-col v-if="form.NotaDebito.proveedor != null"
                               class="pa-0 ma-0 py-0 my-0" cols="12"
                               md="12"
                               sm="12" style="border: 1px solid #000000; font-size: 13px; ">
                          <p class="pa-0 ma-0 py-0 my-0" style="border: 1px dashed  #616161;"><b>Dir.
                          </b>{{ form.NotaDebito.proveedor.direccion }}</p>
                          <p
                            v-if="form.NotaDebito.proveedor.proveedoresTelefonosList != null && form.NotaDebito.proveedor.proveedoresTelefonosList.length > 0"
                            class="pa-0 ma-0 py-0 my-0" style="border: 1px dashed  #616161;">
                            <b>Tel.</b>{{
                              form.NotaDebito.proveedor.proveedoresTelefonosList[0].proveedoresTelefonosPK.telefono
                            }}
                            <b>Ext.</b> 0000 .</p>
                          <p class="pa-0 ma-0 py-0 my-0" style="border: 1px dashed  #616161;"><b>Balance: $
                            {{ form.NotaDebito.proveedor.balanceproveedor.balance }}</b></p>

                        </v-col>


                      </v-col>
                      <!-- columna 4 ------------------------------>

                    </v-row>
                  </v-form>
                </div>


                <v-col v-if="form.NotaDebito.proveedor != null" class="pa-0 ma-0 py-0 my-0" cols="12" md="12" sm="12">
                  <v-row no-gutters>
                    <v-col cols="12" md="5" sm="5">
                      <v-card v-if="ListDevPend.length > 0" style="border: 1px solid #000000;">
                        <v-toolbar color="#BDBDBD" dense flat>
                          <v-toolbar-title class="font-weight-light">
                            <v-card-title>DEVOLUCIONES PENDIENTES</v-card-title>
                          </v-toolbar-title>
                        </v-toolbar>

                        <v-data-table v-model="selectedDevolucion" :headers="[
                          { text: 'FECHA', value: 'fecha', sortable: false, class: ['no-gutters'] },
                          { text: 'DEVOLUCIONES', value: 'devolucion', sortable: false, class: ['no-gutters'] },
                          { text: 'VALOR', value: 'valor', sortable: false, class: ['no-gutters'] },
                        ]" :items="ListDevPend" :items-per-page="5" :show-select="showSlectDevolucion" :single-select="false" class="elevation-1"
                                      dense item-key="indx"
                                      @item-selected="obtenerDatoDevolucion" @toggle-select-all="allobtenerDatoDevolucion">
                          <template v-slot:item.fecha="props">
                            <span style="font-size:13px; display:none;">{{
                                props.item.indx =
                                  ListDevPend.indexOf(props.item)
                              }}</span>
                            <span style="font-size:13px;">{{ FormatoFecha(props.item.fecha) }}</span>
                          </template>

                          <template v-slot:item.valor="props">
                            <span style="font-size:13px;">{{ currencyFormatter(props.item.valor) }}</span>
                          </template>

                          <template v-slot:item.devolucion="props">
                            <span style="font-size:13px;"> {{ props.item.devolucionproveedorPK.secuencia }}</span>
                          </template>
                        </v-data-table>


                      </v-card>

                    </v-col>

                    <v-col v-if="modoPendientePago()==true" cols="12" md="7" sm="7"
                           style="border: 1px solid #000000;">

                      <v-card>
                        <v-toolbar color="#BDBDBD" dense flat>
                          <v-toolbar-title class="font-weight-light">
                            <v-card-title>FACTURAS</v-card-title>
                          </v-toolbar-title>
                          <!-- @keyup="SeachFilProducto" background-color="white" color="grey darken-4" -->
                                    <!-- <v-row></v-row> -->
                                    <v-col  class="pa-0 ma-0 py-0 my-0 px-2" cols="6" md="8" sm="8">
                                      <v-tooltip top>
                                        <template v-slot:activator="{ on }">
                                          <v-text-field
                                            ref="RefTextFieldSearchCheque"
                                            v-model="searchFactura"
                                            autocomplete="off"
                                            class="fontSize13 black--text"
                                            color="black"
                                            dense
                                            hide-details
                                            label="BUSCAR POR SECUENCIA O NCF:"
                                            outlined
                                            @keyup.enter="buscarFacKeyEnter"
                                            v-on="on"
                                          >
                                            <template v-slot:prepend-inner>
                                              <i class="fa fa-search" style="font-size: 25px"></i>
                                            </template>
                                          </v-text-field>
                                        </template>
                                        <span>Busqueda: NOTA: PRESIONAR ENTER PARA BUSCAR</span>
                                      </v-tooltip>
                                    </v-col>
                                    <v-col v-if="$store.getters.GetConfiguracionGeneral.configCxp.permitirNotasdebitoFactsalda==true" class="pa-0 ma-0 py-0 my-0 px-0" cols="6" md="4" sm="4">
                                      <!-- @change="getFacVenta" -->
                                    <v-radio-group @change="changeRadioPenPag" v-model="opcPendientePagado" class="pt-2 mt-0 d-flex justify-center " dense
                                                                           hide-details row >

                                                                           <v-radio :value="true" color="green" label="">
                                                                                                       <template v-slot:label>
                                                                                                         <strong style="color: #000000; font-size: 11px">PENDIENTES</strong>
                                                                                                       </template>
                                                                                                     </v-radio>
                                                                                                     <v-radio id="no-enviada" :value="false" color="green" label="">
                                                                                                       <template v-slot:label>
                                                                                                         <strong style="color: #000000; font-size: 11px">PAGADAS</strong>
                                                                                                       </template>
                                                                                                     </v-radio>
                                                                           </v-radio-group>
                                    </v-col>

                                    
                                    
                                    <!-- <v-toolbar-title>Ordenes De Compras sugeridas</v-toolbar-title> -->

                                    <v-spacer></v-spacer>
                        </v-toolbar>

                        <v-data-table class="RowSelectColor" :single-select="true" item-key="indx" :show-select="true"
                         :loading="loaderTabla"
                         :search="searchFactura"
                         v-model="selectedFactura" @item-selected="obtenerDatoSelectFactura" :headers="[{ text: 'Secuencia', sortable: false, value: 'referencia', width: 120 },
                          { text: 'NCF', sortable: false, value: 'ncf', width: 129 },
                          { text: 'FECHA', sortable: false, value: 'fecha', width: 120 },
                          { text: 'VALOR', sortable: false, value: 'valor', width: 'auto', width: 105 },
                          { text: 'PENDIENTE', sortable: false, value: 'pendiente', width: 'auto', width: 105 },
                          ]" dense :items="RlistFactVent" @click:row="datostablaFact"

                        @pagination="cargarPaginacionFactura"
                       :items-per-page="paginatorFactura.itemsPerPage"
                       :page="paginatorFactura.page"
                       :pageCount="paginatorFactura.pageCount"
                       :server-items-length="TotalRegistrosFactVent"
                          :footer-props="$arrayPropiedasesGlobal"
                          >

                          <template v-slot:item.fecha="props">
                            <span style="font-size:13px; display:none;">{{
                                props.item.indx =
                                  RlistFactVent.indexOf(props.item)
                              }}</span>
                            <span style="font-size:13px;">{{ FormatoFecha(props.item.fecha) }}</span>
                          </template>

                          <template v-slot:item.pendiente="props">
                            <span style="font-size:13px;">{{ currencyFormatter(props.item.pendiente) }}</span>
                          </template>
                          <template v-slot:item.valor="props">
                            <!-- props.item.valor -->
                            <span style="font-size:13px;">{{ currencyFormatter(props.item.valor) }}</span>
                          </template>

                          <!-- -->
                          <template v-slot:no-data>
                          <v-card-title>FACTURAS </v-card-title>
                          <v-sheet v-if="tbLoadeCargar"    :color="`grey ${theme.isDark ? 'darken-2' : 'red darken-1'}`"
                            class="px-3 pt-3 pb-3">
                            <v-skeleton-loader class="mx-auto" max-width="auto" type="card"></v-skeleton-loader>
                          </v-sheet>
                        </template>


                        </v-data-table>


                      </v-card>
                    </v-col>


                  </v-row>
                </v-col>

              </v-card>


            </div>

          </v-app>
        </td>
        <!-- fn contenido central ------------------------------------------------------------------------------------->
        <!-- BarraSecundaria ------------------------------------------------------------------------------------------>
        <td v-show="BarraSecundariaAprir" :max-height="this.windowSize.height - 96" width="109">

          <div class="overflow-y-auto "
               v-bind:style="{ 'max-height': this.windowSize.height - 96 + 'px', 'max-width': '325px', 'width': '325px' }">


            <!-- <BarraBusqueda2
              :url="$hostname + $hName + '/services/caja/findAll'"
              :nombre="'Cajas'"
              :headers="headers"
              :slotname="'item.descripcion'"
              :emitnombre="'emitCaja'"
              :slotlist="slotlist"
              :SeachNombre="'Búsqueda por descripción caja'"
            /> -->
          </div>

        </td>
        <!-- fn BarraSecundaria --------------------------------------------------------------------------------------->


      </tr>
    </table>
    <!-- Modales -------------------------------------------------------------------------------------------------->

    <!-------------------------------------------------------- tb-data-->
    <v-dialog v-model="acti_tb_data" fullscreen hide-overlay label="myAlert" persistent
              transition="dialog-bottom-transition">
      <v-card>
        <v-toolbar color="#BDBDBD" dense flat>
          <i class="fa fa-file-pdf-o" style="font-size: 20px;"> </i>
          <v-toolbar-title class="font-weight-light">
            REPORTE
          </v-toolbar-title>
          <i class="fa fa-file-pdf-o" style="font-size: 20px;"> </i>

          <v-spacer></v-spacer>
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn color="deep-purple accent-2" dark small v-on="on" @click.prevent="OpendialogimprimirListFilt()">
                <i class="fa fa-print" style="font-size: 25px;"> </i>
                Listado
              </v-btn>

            </template>
            <span>Imprimir Listado</span>
          </v-tooltip>
          <v-btn color="grey darken-4" fab small @click="actualiza_tb_ver">
            <i class="fa fa-close" style="font-size: 20px; color:#dd4b39;"></i>
          </v-btn>
        </v-toolbar>

        <v-card-text>
          <v-card>
            <v-card-title>
              <v-text-field v-model="Modallfiltro.codigo" hide-details label="Búsqueda por código"
                            single-line type="number" @keyup.enter="CargarListTb">
                <template v-slot:prepend-inner>
                  <i class="fa fa-search" style="font-size: 35px;"></i>
                </template>

                <template v-slot:append-outer>
                  <v-btn color="teal darken-2" dark small
                         @click.prevent="dialogFiltros = true, ObjTemTbDinam = JSON.parse(JSON.stringify(Modallfiltro))">
                    <i class="fa fa-search" style="font-size: 25px;"> </i>
                    Filtros
                  </v-btn>
                </template>

              </v-text-field>
            </v-card-title>
            <v-data-table :headers="[
              { text: 'Código', value: 'notadebitoproveedoresPK.codigo', sortable: false, class: ['no-gutters black--text'] },
              { text: '#Documento', value: 'referencia', sortable: false, class: ['no-gutters black--text'] },
              { text: 'Fecha', value: 'nuevaFecha', width: 120, sortable: false, class: ['no-gutters black--text'] },
              { text: 'Proveedor', value: 'proveedor.nombre', sortable: false, class: ['no-gutters black--text'] },
              { text: 'Valor', value: 'valor', sortable: false, class: ['no-gutters black--text'] },
              { text: 'Documento', value: 'documentoproveedor.descripcion', sortable: false, class: ['no-gutters black--text'] },
              { text: 'Categoria', value: 'gasto.descripcion', sortable: false, class: ['no-gutters black--text'] },
              { text: 'Moneda', value: 'moneda.descripcion', sortable: false, class: ['no-gutters black--text'] },
              { text: 'Comentario', value: 'concepto', sortable: false, class: ['no-gutters black--text'] },
              { text: 'Estado', value: 'activa', sortable: false, class: ['no-gutters black--text'] }
            ]" :items="ListItems" :items-per-page="TbPaginator.itemsPerPage" :page="TbPaginator.page" :pageCount="TbPaginator.pageCount"
                          :search="Modallfiltro.factura"
                          :server-items-length="TbTotalItem" class="TbSize13" dense
                          @pagination="cargarPaginacionAll" @click:row="datostabla">
              <template v-slot:item.valor="props">
                <span>{{ currencyFormatter(props.item.valor) }}</span>
              </template>

              <template v-slot:item.nuevaFecha="props">
                <span>{{ FormatoFecha(props.item.nuevaFecha) }}</span>
              </template>

              <template v-slot:item.activa="props">
                <span v-if="props.item.activa == true">Activo</span>
                <span v-if="props.item.activa == false">Anulado</span>
              </template>

            </v-data-table>
          </v-card>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- ------------------------------------------------------ fn tb-data-->


    <!-- ------------------------------------------------------ notif-->
    <v-dialog v-model="notif.estado" label="myAlert" max-width="350" persistent transition="fab-transition">
      <template v-slot:activator="{ on }" justify="center"></template>

      <v-card>
        <v-card-title>
          <h4>
            <i class="fa fa-warning" style="font-size: 28px;"></i>
            CONFIRMACION
            <i class="fa fa-warning" style="font-size: 28px;"></i>
          </h4>
        </v-card-title>
        <hr />

        <v-card-text>
          <h5>{{ notif.nombre }}</h5>
        </v-card-text>

        <hr />
        <v-card-actions>
          <v-btn v-if="notif.Exec == 'AnularDebito'" small @click.prevent="anular(), (notif.estado = !notif.estado)">
            <i class="fa fa-check" style="font-size: 20px;"></i> Si
          </v-btn>

          <v-btn v-if="notif.Exec == 'EliminarDebito'" small
                 @click.prevent="eliminar(), (notif.estado = !notif.estado)">
            <i class="fa fa-check" style="font-size: 20px;"></i> Si
          </v-btn>

          <v-btn v-if="notif.Exec == 'ContinuarSinDevolucion'" small
                 @click.prevent="continuarSinDevolucionPendiente()">
            <i class="fa fa-check" style="font-size: 20px;"></i> Si
          </v-btn>

          <v-btn small @click.prevent="cancelarSinDevolucionPendiente()">
            <i class="fa fa-ban" style="font-size: 20px;"></i> No
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- ------------------------------------------------------  fn notif -->

    <!-- ------------------------------------------------------   alerta -->
    <v-snackbar id="alerMov" v-model="aalert.estado" :color="aalert.color" :timeout="120000" :vertical="true" top="top">
      {{ aalert.nombre }}
      <v-btn dark text @click="aalert.estado = false">Close</v-btn>
    </v-snackbar>
    <!-- ------------------------------------------------------  fn alerta -->


    <!-- ------------------------------------------------------ Modal- agregar cuenta-->
    <v-dialog v-model="acti_Modal_cuenta" label="Modal agregar cuenta" max-height="50%" max-width="80%"
              persistent transition="fab-transition">

      <CuentasContables ref="RefCuentasContables" :RLisCuenta="RLisCuenta" :Total="TotalCuenta"
                        :objeTem="objeTem"
                        @CuentasContables="CCuentasContables" />

    </v-dialog>
    <!-------------------------------------------------------- fn Modal agregar cuenta-->

    <!-------------------------------------------------------- Modal Filtro -->
    <v-dialog v-model="dialogFiltros" label="Modal agregar factura" max-height="80%" max-width="90%"
              persistent transition="fab-transition">
      <v-card>
        <v-toolbar color="indigo" dense flat>
          <i class="" style="font-size: 20px;"> </i>
          <v-toolbar-title class="font-weight-light" style="color:white;"><b>FILTROS</b></v-toolbar-title>
          <i class="" style="font-size: 20px;"> </i>
          <v-spacer></v-spacer>
          <v-btn color="grey darken-4" fab small
                 @click="dialogFiltros = false, Modallfiltro = JSON.parse(JSON.stringify(ObjTemTbDinam))">
            <i class="fa fa-close" style="font-size: 20px; color:white;"></i>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <br>
          <v-row>
            <v-col cols="12" md="6" sm="6">
              <!-------------------------------------------------- Nombre  -->
              <v-combobox v-model="Modallfiltro.proveedores" :items="Rproveedor" autocomplete="off" dense item-text="nombre"
                          label="Proveedor:" outlined style="font-size: 13px;"
                          @blur="SelctCbProveedoresFiltro" @focus="cargarProveedor" @keyup="CbFilProveedor">
                <template v-slot:prepend>
                  <i class="fa fa-user-circle" style="font-size: 20px;"></i>
                </template>
              </v-combobox>
            </v-col>

            <v-col cols="12" md="6" sm="6">

              <!---------------------------------------------- documento -->
              <v-combobox v-model="Modallfiltro.documento" :items="RDocumento" :rules="[$rules.required]" autocomplete="off" dense
                          item-text="descripcion" label="Documentos:" outlined
                          @blur="SelctCbDocumentoFiltro" @focus="cargarDocumento">
                <template v-slot:prepend>
                  <i class="fa fa-book" style="font-size: 20px;"></i>
                </template>
              </v-combobox>

            </v-col>

            <!-- -----------------------------  columna-1 -->
            <v-col cols="12" md="6" sm="6">

              <!----------------------------------------------  Desde -->
              <v-text-field v-model="Modallfiltro.Desde" dense label="Desde*" outlined type="date">
                <template v-slot:prepend>
                  <i class="fa fa-calendar" style="font-size: 20px;"></i>
                </template>
              </v-text-field>
            </v-col>
            <!-- ----------------------------- fn columna-1 -->
            <!-- -----------------------------  columna-2 -->
            <v-col cols="12" md="6" sm="6">
              <!-------------------------------------------------- Hasta -->
              <v-text-field v-model="Modallfiltro.Hasta" dense label="Hasta*" outlined type="date">
                <template v-slot:prepend>
                  <i class="fa fa-calendar" style="font-size: 20px;"></i>
                </template>

              </v-text-field>


            </v-col>
            <!-- ----------------------------- fn columna-2 -->

          </v-row>


        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn-toggle class="" dense rounded>


            <v-btn color="#90A4AE" @click.prevent="Limpiarfiltro">
              <i class="fa fa-file-o" style="font-size: 28px;"> </i>
              Limpiar filtro
            </v-btn>

            <v-btn color="blue lighten-1" @click.prevent="BuscarFiltros">
              <i class="fa fa-search" style="font-size: 28px;"> </i>
              Buscar
            </v-btn>

          </v-btn-toggle>

        </v-card-actions>

      </v-card>
    </v-dialog>

    <!-------------------------------------------------------- fn Modal filtro -->

    <!-- ------------------------------------------------------ Modal- Reportes-->
    <v-dialog v-model="dialogimprimirListFilt" label="Modal agregar cuenta" max-height="50%" max-width="80%"
              persistent transition="fab-transition">
      <!----------------------------------------------------------------- Cuerpo Reporte -->
      <v-card color="grey lighten-3">

        <v-toolbar color="#BDBDBD" dense flat style="border: 1px solid #000000;">

          <v-avatar size="45" tile>
            <img alt="Reporte" src="@/assets/iconos_micromarket/custom-reports.png">
          </v-avatar>
          <span class="font-weight-light" style="font-size: 20px;"> <b>REPORTE LISTADO REGISTRO NOTAS DE DÉBITO A
              PROVEEDORES</b> </span>

          <v-spacer></v-spacer>
          <v-btn color="red" fab small @click.prevent="dialogimprimirListFilt = false">
            <i class="fa fa-close" style="font-size: 20px; color:white;"></i>
          </v-btn>
        </v-toolbar>

        <hr>

        <v-container style="border: 1px solid #000000;">
          <v-form ref="form" v-model="valid" lazy-validation @submit.prevent="">
            <v-row class="pa-0 ma-0">


              <v-col cols="12" md="6" sm="6">
                <!---------------------------------------------- documento -->
                <v-combobox v-model="datosImprecionAll.documentos" :items="RDocumento" :rules="[$rules.required]" autocomplete="off" dense
                            item-text="descripcion" label="Documentos:" outlined
                            @blur="SelctCbReportDocumento" @focus="cargarDocumento">
                  <template v-slot:prepend>
                    <i class="fa fa-book" style="font-size: 20px;"></i>
                  </template>
                </v-combobox>
              </v-col>

              <v-col cols="12" md="6" sm="6">
                <v-combobox v-model="datosImprecionAll.proveedores" :items="Rproveedor" autocomplete="off" dense item-text="nombre"
                            label="Proveedor:" outlined style="font-size: 13px;"
                            @blur="SelctCbReportProveedores" @focus="cargarProveedor" @keyup="CbFilProveedor">
                  <template v-slot:prepend>
                    <i class="fa fa-user-circle" style="font-size: 20px;"></i>
                  </template>
                </v-combobox>
              </v-col>
              <v-col cols="12" md="6" sm="6">
                <v-text-field v-model="datosImprecionAll.desde" :rules="[$rules.required]" dense label="Desde*" outlined
                              type="date" @blur="ReportBlurDesde">

                  <template v-slot:prepend>
                    <i class="fa fa-calendar" style="font-size: 20px;"></i>
                  </template>
                </v-text-field>


              </v-col>

              <v-col cols="12" md="6" sm="6">


                <!-------------------------------------------------- Hasta -->
                <v-text-field v-model="datosImprecionAll.hasta" :rules="[$rules.required]" dense label="Hasta*" outlined
                              type="date" @blur="ReportBlurHasta">
                  <template v-slot:prepend>
                    <i class="fa fa-calendar" style="font-size: 20px;"></i>
                  </template>
                </v-text-field>


              </v-col>
            </v-row>
          </v-form>
        </v-container>

        <hr>

        <ModalReporteFiltros ref="ModRepfil" :Datos="datosImprecionAll" @DataReporteBasico="DDataReporteBasico" />

      </v-card>
      <!-------------------------------------------------------------------------------- Fn Cuerpo Reporte -->

    </v-dialog>
    <!-- ------------------------------------------------------ fn Modal reportes -->


    <!-- ------------------------------------------------------ Modal- Reporte Basico-->
    <v-dialog v-model="dialogimprimirList" label="Modal Reporte Basico" max-height="50%" max-width="80%"
              persistent transition="fab-transition">


      <ModalReporteBasico :Datos="datosImprecion" @DataReporteBasico="DDataReporteBasico" />

    </v-dialog>
    <!-- ------------------------------------------------------ fn Modal Reporte Basico-->


    <!-- fn Modales ----------------------------------------------------------------------------------------------->


  </div>

</template>

<script>

import BarraBusqueda2 from "../../components/BarraBusquedaDinam"
import CrearProducto from "../../CuentaXPagar/UtilidadComponents/CrearProducto"
import AutoNumeric from "../../components/AutoNumericNuevo"
import { EventBus } from "../../event-bus"
import ContenidoBase from "../../components/ContenidoBase"
import CuentasContables from "../../components/CuentasContables"
import BarraDinamicaNormal from "../../components/BarraDinamicaNormal"
import { currencyFormatter, fechaNueva, FormatoFecha, HoraFormatter, RedondeoValorCantRed } from "@/js/Funciones.js"
import BarraDinamicaLimitePlus from "../../components/BarraDinamicaLimitePlus"
import ModalReporteFiltros from "../../components/ModalReporteFiltros"
import ModalReporteBasico from "../../components/ModalReporteBasico"

export default {
   inject: ['theme'],
  components: {
    AutoNumeric,
    BarraBusqueda2,
    CrearProducto,
    ContenidoBase,
    CuentasContables,
    BarraDinamicaNormal,
    BarraDinamicaLimitePlus,
    ModalReporteFiltros,
    ModalReporteBasico,
  },
  mounted() {
    EventBus.$on("abrirMenuizquierdo", this.abrirTabla)
    //EventBus.$on("abrirMenuizquierdo", this.abrirTabla2);
    //EventBus.$on("emitNotaDebito", this.datostabla);
    // EventBus.$on("cxpNotaDebitoNew", this.new);
    // EventBus.$on("cxpNotaDebitoSave", this.save);
    // EventBus.$on("cxpNotaDebitoRemove", this.remove);
    // EventBus.$on("cxpNotaDebitoAnular", this.anular);
    // EventBus.$on("cxpNotaDebitoPrintList", this.imprimirList);
    // EventBus.$on("cxpNotaDebitoVercuenta", this.vercuenta);
    EventBus.$on("onResize", this.onResize)
    //this.filtro();
  },

  created() {
    var json = {
      titulo: "Notas de Débito a los Proveedores.",
      descripcion:
        "Registrar Notas de Débito a los Proveedores.",
      save: true,
      eliminar: true,
      anular: false,
      nuevo: true,
      imprimir: false,
      vercuenta: true,

      accion: [
        "cxpNotaDebitoNew",
        "cxpNotaDebitoSave",
        "cxpNotaDebitoRemove",
        "cxpNotaDebitoAnular",
        "cxpNotaDebitoPrintList",
        "cxpNotaDebitoVercuenta",
      ],
    }
    EventBus.$emit("anularBotonesAccion", json)
  },
  data() {
    return {
      windowSize: { width: "auto", height: "auto" },
      valid: true,
      ejecucion: true,
      loaderTabla: false,
      tbLoadeCargar:false,
      boolVerificarProveedorNcf: false,
      dialogOrdenSugerida: false,
      acti_Modal_cuenta: false,
      //ListDevPend,showSlectDevolucion,obtenerDatoDevolucion,allobtenerDatoDevolucion,selectedDevolucion
      Rproveedor: [],
      showSlectDevolucion: true,
      selectedDevolucion: [],
      searchFactura:"",
      dialogimprimirList: false,
      datosImprecion: {
        nombre: "NOTAS DE DÉBITO A LOS PROVEEDORES",
        UrlImprimir: "/notadebitoproveedores/imprimir",
        UrlExel: "/notadebitoproveedores/excel",
        UrlCorreo: "/notadebitoproveedores/correo",
      },
      dialogimprimirListFilt: false,
      datosImprecionAll: {
        nombre: "LISTADO REGISTRO NOTAS DE DÉBITO A PROVEEDORES",
        UrlImprimir: "/notadebitoproveedores/ImprimirList",
        UrlExel: "/notadebitoproveedores/ExcelList",
        UrlCorreo: "/notadebitoproveedores/CorreoList",
        desde: fechaNueva(),
        hasta: fechaNueva(),
        documentos: null,
        proveedores: null,
      },
      opcPendientePagado:true,

      dialogFiltros: false,
      Modallfiltro: {
        proveedores: null,
        codigo: null,
        documento: null,
        Desde: null,
        Hasta: null,
      },

      ObjTemTbDinam: null,
      ListItems: [],
      TbTotalItem: 0,
      TbPaginator: {
        page: 1,
        itemsPerPage: 5,
        pageStart: 0,
        pageStop: 15,
        pageCount: 10,
        itemsLength: 5,
      },


      selectedFactura: [],
      RlistFactVent: [],
      RlistFactVentTemp: [],
      TotalRegistrosFactVent: 1,

      paginatorFactura: {
        itemsPerPage: 15,
        pageStart: 0,
        page: 1,
        pageStop: 15,
        pageCount: 10,
        itemsLength: 5,
      },


      Rmoneda: [],
      Rproveedor: [],
      RallProducto: [],
      Rdepartamento: [],
      Ralmacen: [],
      RDocumento: [],
      RTipoGasto: [],
      RLisCuenta: [],


      aalert: {
        estado: false,
        color: null,
      },

      notif: {
        estado: false,
        nombre: "",
        Exec: "",
      },


      search: "",
      objeTem: null,
      TotalCuenta: null,
      contabilidad: null,
      ListDevPend: [],
      editCuentasC:false,
      form: {
        NotaDebito: {
          notadebitoproveedoresPK: { codigo: 0, documento: 0 },
          codigo: 0,
          fecha: fechaNueva(),
          moneda: null,
          proveedor: null,
          direccionEnvio: "",
          concepto: "",
          descuentoIndividual: 0,
          tasa: 0,
          documentoproveedor: null,
          ncf: "",
          valor: 0,
          itbis: 0,
          contabilidad: null,
          referencia: "",
          gasto: null,
          activada: true,
          activa: true,


        },

        RLisCuenta: [],
        editCuentasC:false,
        TotalCuenta: {
          credito: 0,
          debito: 0,

        },

        Total: {
          valor: 0,
          pendiente: 0,
          ncr: 0,
          itbis: 0,
          balanceTotal: 0,
        },
      },

      EstadoBtn: {
        BarraTablaDinamicaAprir: true,
        nuevo: true,
        guardar: true,
        eliminar: false,
        anular: false,
        imprimir: true,
        vercuenta: false,
        guardartemporal: false,
        restaurartemporal: false,
        importarDato: false,
        cargarProducto: false,
        ImprimirproductoInv: false,
      },

      headers: [{ text: "Tarjeta", value: "nombre" }],

      slotlist: [
        { dt0: "codigo", dt1: null, dt2: null, dt3: 1, dt4: "Código:" },
        { dt0: "nombre", dt1: null, dt2: null, dt3: 1, dt4: "nombre:" },
        { dt0: "porciento", dt1: null, dt2: null, dt3: 5, dt4: "Porciento:" },
      ],


      list: [],
      search: "",
      acti_tb_data: false,

      BarraTablaDinamicaAprir: false,
      BarraSecundariaAprir: false,
    }
  },

  methods: {

    currencyFormatter, FormatoFecha, HoraFormatter, fechaNueva, RedondeoValorCantRed,

    onResize(e) {
      //this.windowSize=e
    },
    //Original
    findDetalle_Original() {
      if (this.form.NotaDebito.notadebitoproveedoresPK.codigo == 0) {

        this.$axios.get(this.$hostname + this.$hName + '/notadebitoproveedores/findDetalle/' + this.form.NotaDebito.proveedor.codigo, { headers: this.$store.getters.GetheadersAxios }).then(res => {
          if(res.data.length>0){
          this.RlistFactVent = JSON.parse(JSON.stringify(res.data));
          this.RlistFactVentTemp=JSON.parse(JSON.stringify(res.data));
          this.TotalRegistrosFactVent=res.data.length
         }else{
          this.RlistFactVent = [];
          this.RlistFactVentTemp=[];
          this.TotalRegistrosFactVent=1
         }

        });
      }
    },

findDetalle() {

  console.log('findDetalle--->',this.opcPendientePagado)
  // "/notadebitoproveedores/findDetallePendienteLimitado/847/15/1/A"
  //       "/findDetallePendienteLimitado/{proveedor}/{limit}/{ultimo}/{busqueda}

      if (this.form.NotaDebito.notadebitoproveedoresPK.codigo == 0) {

        // ObjMap.put("limit", limit);
        // ObjMap.put("ultimo", ultimo);
        // ObjMap.put("busqueda", busqueda);
        // ObjMap.put("proveedor", proveedor);

        var PARAMS={
              proveedor: this.form.NotaDebito.proveedor.codigo,
              limit: this.paginatorFactura.itemsPerPage,
              ultimo: this.paginatorFactura.pageStart,
              busqueda:this.searchFactura
        }
        // var LINK =`/${this.form.NotaDebito.proveedor.codigo}/${this.paginatorFactura.itemsPerPage}/${this.paginatorFactura.pageStart}/A`

        var Link=this.opcPendientePagado==true?'findDetallePendienteLimitado':'findDetalleFactProveeSaldaLimitado'

        this.tbLoadeCargar=true
        this.$axios.get(this.$hostname + this.$hName + `/notadebitoproveedores/${Link}`,
        { headers: this.$store.getters.GetheadersAxios,
        params: PARAMS
        })
        .then(res => {
          this.tbLoadeCargar=false
          if(res.data.ListDetalle.length>0){
          this.RlistFactVent = JSON.parse(JSON.stringify(res.data.ListDetalle));
          this.RlistFactVentTemp=JSON.parse(JSON.stringify(res.data.ListDetalle));
          this.TotalRegistrosFactVent=res.data.TbTotalItem
          console.log('---res.data.TbTotalItem->',res.data.TbTotalItem)
         }else{
          this.RlistFactVent = [];
          this.RlistFactVentTemp=[];
          this.TotalRegistrosFactVent=1
         }
         console.log('ListDetalle.length-->',res.data.ListDetalle.length)
         if(this.opcPendientePagado==true && res.data.ListDetalle.length==0){
            this.opcPendientePagado=false
            var _this = this
          setTimeout(function() {
            _this.findDetalle()
          }, 1000)
         }

          
        });
      }
    },



    findDevolucion() {
      if (this.form.NotaDebito.notadebitoproveedoresPK.codigo == 0) {

        this.$axios.get(this.$hostname + this.$hName + "/devolucionproveedores/findAllDevolucionesPendientes/" + this.form.NotaDebito.proveedor.codigo, { headers: this.$store.getters.GetheadersAxios }).then(res => {
          if (res.data.length > 0) {
            this.ListDevPend = JSON.parse(JSON.stringify(res.data))
          } else {
            this.ListDevPend = []
          }

        })
      }
    },
    async vercuenta() {

      if (!this.$refs.form.validate()) {
        this.alerta("Los campos en rojo son requeridos", "error")
        return
      }

      if (this.$refs.form.validate()) {
        await this.getCrearCont()
        this.objeTem = JSON.parse(JSON.stringify(this.RLisCuenta))
        this.TotalCuenta = JSON.parse(JSON.stringify(this.form.TotalCuenta))
        this.acti_Modal_cuenta = !this.acti_Modal_cuenta

        var _this = this
        setTimeout(function() {
          _this.calcularTotalcuenta(1)
          _this.$refs.RefCuentasContables.calcularTotal(1)
        }, 500)


      } else {
        this.alerta("Los campos en rojo son requeridos", "error")
      }


    },


    CargarRTipopago() {
      this.$axios.get(this.$hostname + this.$hName + "/categoriagastos/findallactivo", { headers: this.$store.getters.GetheadersAxios }).then(res => {
        this.RTipoGasto = res.data
      })
    },


    SelctCbTipoGasto() {


      if (this.form.NotaDebito.gasto == null) {
        this.form.NotaDebito.gasto = ""
      }

      if (this.form.NotaDebito.gasto.codigo == undefined) {
        this.alerta("Seleccione un tipo gasto", "error")
        this.form.NotaDebito.gasto = ""
        return
      }

    },


    cargarDocumento() {

      this.$axios.get(this.$hostname + this.$hName + "/documentoscxp/findAllDocumentosNotaDebito", { headers: this.$store.getters.GetheadersAxios })
        .then(res => (this.RDocumento = res.data))

    },

    SelctCbDocumento() {
      if (this.form.NotaDebito.documentoproveedor == null) {

        this.form.NotaDebito.documentoproveedor = ""
      }

      if (this.form.NotaDebito.documentoproveedor.codigo == undefined) {

        this.alerta("Seleccione un documento", "error")
        this.form.NotaDebito.documentoproveedor = ""
        return

      }

    },

    getCrearCont() {

      if (!this.$refs.form.validate()) {
        return Promise.resolve()
      }

      if (this.$refs.form.validate()) {
        if ( this.editCuentasC==false && this.form.NotaDebito.notadebitoproveedoresPK.codigo == 0) {
         EventBus.$emit("loading", true);
          return this.$axios.get(this.$hostname + this.$hName + "/contabilidad/crear-contabilidad-cxp/" + this.form.NotaDebito.documentoproveedor.codigo + "/" + this.form.NotaDebito.valor + "/" + this.form.NotaDebito.itbis + "/0/0/0",
            { headers: this.$store.getters.GetheadersAxios })
            .then(res => {
              this.llenarcuenta(res.data)
              EventBus.$emit("loading", false);
            })
            .catch(error => {
              EventBus.$emit("loading", false)
              this.alerta(error, "error")
            })
        }
        if ( this.RLisCuenta.length==0 && this.form.NotaDebito.notadebitoproveedoresPK.codigo != 0) {
         EventBus.$emit("loading", true);
          return this.$axios.get(this.$hostname + this.$hName + "/contabilidad/findContabilidad/" + this.form.NotaDebito.notadebitoproveedoresPK.documento + "/" + this.form.NotaDebito.notadebitoproveedoresPK.codigo + "/" + this.form.NotaDebito.documentoproveedor.operacion.codigo,
            JSON.parse(JSON.stringify(this.form.NotaDebito)))
            .then(res => {
              this.llenarcuenta(res.data)
              EventBus.$emit("loading", false);
            })
            .catch(error => {
              EventBus.$emit("loading", false)
              this.alerta(error, "error")
            })
        }
      }
      return Promise.resolve()

    },

    llenarcuenta(e) {
      //var e =JSON.parse(JSON.stringify(ee))
      // e.fecha=new Date(ee.fecha).toISOString().substr(0,10);
      if (typeof e === "object" && e != null) {
        this.contabilidad = e
      } else if (typeof this.contabilidad != "object" || this.contabilidad === null) {
        this.contabilidad = {
          activo: true,
          borrado: false,
          comentario: "",
          contabilidadDetalleList: [],
          documento: this.form.NotaDebito.documentoproveedor.codigo,
          dsc: null,
          empresa: 0,
          entradaDiario: null,
          fecha: this.form.NotaDebito.fecha,
          id: null,
          operaciones: this.form.NotaDebito.documentoproveedor.operacion,
          referencia: "",
        }
      }

      if (typeof this.contabilidad === "object" && this.contabilidad !== null) {
        this.contabilidad.fecha = this.form.NotaDebito.fecha
        this.contabilidad.documento = this.form.NotaDebito.documentoproveedor.codigo
      }

      if (e != null && e.contabilidadDetalleList != null && typeof e.contabilidadDetalleList === "object" && e.contabilidadDetalleList.length > 0) {
        var _this = this
        setTimeout(function() {
          _this.RLisCuenta = JSON.parse(JSON.stringify(e.contabilidadDetalleList))
          _this.form.RLisCuenta = JSON.parse(JSON.stringify(_this.RLisCuenta))
          _this.objeTem = JSON.parse(JSON.stringify(_this.RLisCuenta))
          _this.calcularTotalcuenta(1)
        }, 500)

      }

    },


    calcularTotalcuenta(e) {

      this.form.TotalCuenta.credito = 0
      this.form.TotalCuenta.debito = 0

      if (e.toString().length > 0) {
        Promise.all(this.RLisCuenta.map(async (element) => {
          this.form.TotalCuenta.credito += element.credito
          this.form.TotalCuenta.debito += element.debito
        }))

        /*this.RLisCuenta.forEach(element => {
          this.form.TotalCuenta.credito += element.credito
          this.form.TotalCuenta.debito += element.debito
        });*/
      }

    },


    CCuentasContables(e, t, b) {

      if (e != undefined) {

        if (e.length == 0) {

          this.getCrearCont()

        } else {
          // this.form.RLisCuenta= JSON.parse(JSON.stringify(e));
          // this.form.TotalCuenta=JSON.parse(JSON.stringify(t)) 
          this.RLisCuenta = JSON.parse(JSON.stringify(e))
          //this.RLisCuenta= this.RLisCuenta
          this.TotalCuenta = JSON.parse(JSON.stringify(t))
        }
      }


      // this.form.RLisCuenta= JSON.parse(JSON.stringify(e));
      // this.form.TotalCuenta=JSON.parse(JSON.stringify(t)) 

      this.RLisCuenta = JSON.parse(JSON.stringify(e))
      this.form.RLisCuenta = this.RLisCuenta
      this.form.TotalCuenta = JSON.parse(JSON.stringify(t))
      this.acti_Modal_cuenta = b
      this.editCuentasC=true

    },


    async allobtener() {

    },


    obtenerDatoDevolucion(e) {

    },

    allobtenerDatoDevolucion(e) {
      if (e.value == true) {
        // this.ListDevPend=[]
        // setTimeout(this.allobtener,200);
      }

      if (e.value == false) {
        // this.ListDevPend=[]
        // setTimeout(this.allobtener,200);
      }

    },


    cargarPaginacionFactura(e) {

      this.selectedFactura = []
      this.paginatorFactura = e

      if (this.paginatorFactura.itemsPerPage == -1) {
        this.paginatorFactura.itemsPerPage = 15
      }

      this.getFacVenta()

    },


    getFacVenta() {
      this.findDetalle()

    },

    AplicarAbonoFactura() {

      if (this.form.NotaDebito.valor > 0 && this.selectedFactura.length > 0) {
        var ObjSelect = JSON.parse(JSON.stringify(this.selectedFactura[0]))
        this.selectedFactura[0].pendiente = (ObjSelect.pendiente - this.form.NotaDebito.valor)
        // var ObjProRow = this.ListaProdxLote.filter((ee) => ee.fechaVencimiento.codigo != e.lote && ee.fechaVencimiento.fecha<FechSel);
      }


    },

    BlurSelectAplicaAbonoFact() {
      if(this.opcPendientePagado==true){
        if (this.selectedFactura.length > 0) {
        var OBJSELECT = JSON.parse(JSON.stringify(this.selectedFactura[0]))
        OBJSELECT.pendiente = JSON.parse(JSON.stringify(OBJSELECT.pendienteOriginal))
        this.datostablaFact(OBJSELECT)
      }
      }
    },


    obtenerDatoSelectFactura(e) {
      //this.datostabla(e.item)
      // this.RlistFactVent = JSON.parse(JSON.stringify(this.RlistFactVentTemp))
      // this.selectedFactura[0].pendienteDespues = e.item.pendiente - this.form.NotaDebito.valor
      if (e.value == false) {
        this.selectedFactura = []
        this.RlistFactVent = JSON.parse(JSON.stringify(this.RlistFactVentTemp))
        this.loaderTablaCargar()
        return
      }

      this.datostablaFact(e.item)
    },


    async datostablaFact(e) {

      this.selectedFactura = []
      // this.RLisCuenta = []
      // this.RlistFactVent=[]
      this.RlistFactVent = JSON.parse(JSON.stringify(this.RlistFactVentTemp))
      var ObjProRow = []
      var OBJ = JSON.parse(JSON.stringify(e))
      this.asignar(e)

      var indexList = -1
      if (e.gastos != null) {
        indexList = this.RlistFactVent.findIndex((ee) => ee.gastos != null && ee.gastos.gastosPK.secuencia == e.gastos.gastosPK.secuencia && ee.gastos.gastosPK.documento == e.gastos.gastosPK.documento)
      }

      if (e.factura != null) {
        indexList = this.RlistFactVent.findIndex((ee) => ee.factura != null && ee.factura.facturasProveedoresPK.codigo == e.factura.facturasProveedoresPK.codigo && ee.factura.facturasProveedoresPK.documento == e.factura.facturasProveedoresPK.documento)
      }
//indexList
      if (e.notacredito != null) {
        indexList = this.RlistFactVent.findIndex((ee) => ee.notacredito != null && ee.notacredito.notacreditoproveedoresPK.codigo == e.notacredito.notacreditoproveedoresPK.codigo && ee.notacredito.notacreditoproveedoresPK.documento == e.notacredito.notacreditoproveedoresPK.documento)
      }

      if ( this.opcPendientePagado==true && this.form.NotaDebito.valor > 0) {
        OBJ.pendiente = this.RedondeoValorCantRed((e.pendiente - this.form.NotaDebito.valor), 2)

        if (OBJ.pendiente < 0) {
          this.alerta("El valor aplicado sobre pasa el pendiente de la factura seleccionada", "error")
        }
      }

      if (indexList !== -1) {
        this.RlistFactVent[indexList] = OBJ
        this.selectedFactura.push(OBJ)
      }
      this.loaderTablaCargar()


      var _this = this
      setTimeout(function() {
        if (_this.RlistFactVent[indexList].pendiente != OBJ.pendiente) {
          _this.RlistFactVent[indexList].pendiente = JSON.parse(JSON.stringify(OBJ.pendiente))
        }

      }, 1000)

    },

    datostablaFact2(e) {
      this.selectedFactura = []
      this.RLisCuenta = []
      this.RlistFactVent = []
      this.RlistFactVent = JSON.parse(JSON.stringify(this.RlistFactVentTemp))
      //selectedFactura,obtenerDatoSelectFactura,RlistFactVent,datostablaFact
      var ObjProRow = []

      // ObjProRow= this.RlistFactVent.filter((ee) => ee.gastos.gastosPK.secuencia == e.gastos.gastosPK.secuencia && ee.gastos.gastosPK.documento == e.gastos.gastosPK.documento);

      if (e.gastos != null) {
        ObjProRow = this.RlistFactVent.filter((ee) => ee.gastos != null && ee.gastos.gastosPK.secuencia == e.gastos.gastosPK.secuencia && ee.gastos.gastosPK.documento == e.gastos.gastosPK.documento)
      }

      if (e.factura != null) {
        ObjProRow = this.RlistFactVent.filter((ee) => ee.factura != null && ee.factura.facturasProveedoresPK.codigo == e.factura.facturasProveedoresPK.codigo && ee.factura.facturasProveedoresPK.documento == e.factura.facturasProveedoresPK.documento)
      }


      if (e.notacredito != null) {
        ObjProRow = this.RlistFactVent.filter((ee) => ee.notacredito != null && ee.notacredito.notacreditoproveedoresPK.codigo == e.notacredito.notacreditoproveedoresPK.codigo && ee.notacredito.notacreditoproveedoresPK.documento == e.notacredito.notacreditoproveedoresPK.documento)
      }

      this.asignar(e)

      if (this.form.NotaDebito.valor > 0 && ObjProRow.length > 0) {
        var ObjSelect = JSON.parse(JSON.stringify(ObjProRow[0]))
        ObjProRow[0].pendiente = this.RedondeoValorCantRed((ObjSelect.pendiente - this.form.NotaDebito.valor), 2)
        // var ObjProRow = this.ListaProdxLote.filter((ee) => ee.fechaVencimiento.codigo != e.lote && ee.fechaVencimiento.fecha<FechSel);
      }


      //  console.log(ObjProRow)
      this.selectedFactura = JSON.parse(JSON.stringify(ObjProRow))


      /* var _this = this;
       setTimeout(function () {
         _this.AplicarAbonoFactura()
     //    _this.getCrearCont()
       }, 300);*/

    },
    asignar(e) {
      if (e.factura != null) {
        this.form.NotaDebito.facturasProveedores = e.factura
      } else {
        this.form.NotaDebito.facturasProveedores = null
      }
      if (e.notacredito != null) {
        this.form.NotaDebito.notacreditoproveedores = e.notacredito
      } else {
        this.form.NotaDebito.notacreditoproveedores = null
      }
      if (e.gastos != null) {
        this.form.NotaDebito.gastos = e.gastos
      } else {
        this.form.NotaDebito.gastos = null
      }
    },
    reAsignar(e) {
      this.RlistFactVent = []
      this.selectedFactura = []
      var objec = null
      if (e.facturasProveedores != null) {
        objec = {
          pendiente: e.pendienteDespues,
          fecha: e.facturasProveedores.fecha,
          valor: e.facturasProveedores.total,
          referencia: (e.facturasProveedores.documentoproveedor.nombrecorto.trim() + "-" + e.facturasProveedores.facturasProveedoresPK.codigo),
          ncf: e.facturasProveedores.ncf,
          factura: e.facturasProveedores,
          notacredito: null,
          gastos: null,
        }

      }
      if (e.notacreditoproveedores != null) {
        objec = {
          pendiente: e.pendienteDespues,
          fecha: e.notacreditoproveedores.fecha,
          valor: e.notacreditoproveedores.valor,
          referencia: (e.notacreditoproveedores.documentoproveedor.nombrecorto.trim() + "-" + e.notacreditoproveedores.notacreditoproveedoresPK.codigo),
          ncf: e.notacreditoproveedores.ncf,
          factura: null,
          notacredito: e.notacreditoproveedores,
          gastos: null,
        }
      }
      if (e.gastos != null) {
        objec = {
          pendiente: e.pendienteDespues,
          fecha: e.gastos.fecha,
          valor: e.gastos.valor,
          referencia: (e.gastos.documentocontable.nombrecorto.trim() + "-" + e.gastos.gastosPK.secuencia),
          ncf: e.gastos.ncf,
          factura: null,
          notacredito: null,
          gastos: e.gastos,
        }
      }
      if (objec != null) {

        this.RlistFactVent.push(objec)

        var _this = this
        setTimeout(function() {
          _this.selectedFactura.push(objec)
          //    _this.getCrearCont()
        }, 500)


        setTimeout(function() {
          _this.getCrearCont()
        }, 900)


        //this.selectedFactura.push({ item: objec, value: true })
      }

    },


    keyupDiaOrden() {

      if (e.key) {
        var mynumeral = require("numeral")
        this.form.OrdenSugerida.dia = mynumeral(this.form.OrdenSugerida.dia).value()
        if (this.form.OrdenSugerida.dia == null) {

          this.form.OrdenSugerida.dia = 0
        }

      } else {
        console.log("no se puede poner letras o signos")
      }

    },

    addClikProd() {

    },


    newCrearProducto() {
    },

    currencyFormatter(params) {
      return this.formatNumber(params)
    },

    formatNumber(number) {
      if (number == null) {
        number = 0
      }
      // var p=Math.trunc(number)
      // var pd=number-p
      return number
        .toFixed(2)
        .toString()
        .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")

      // return Math.floor(number)
      //   .toString()
      //   .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
    },


    FormatoFecha(params0) {
      var params = new Date(params0).toISOString().substr(0, 10)
      if (params != null) {
        if (params.length > 0) {
          return (
            params.substring(8, 10) +
            "-" +
            params.substring(5, 7) +
            "-" +
            params.substring(0, 4)
          )
        }
      }
    },


    async presave() {
      EventBus.$emit("loading", true)
      var _this = this
      setTimeout(function() {
        _this.save()
      }, 1000)
    },
    async save() {

      await this.VerificarProveedorNcf()

      if (this.selectedFactura.length == 0) {
        this.alerta("Debe de seleccionar al menos una factura", "error")
        return
      }


      if (this.selectedFactura[0].pendiente < 0) {
        this.alerta("El valor aplicado sobre pasa el pendiente de la factura seleccionada", "error")
        return
      }


      if (this.boolVerificarProveedorNcf == true) {
        this.alerta("NOTA: EL NCF ya fue registrado con el proveedor seleccionado", "error")
        return
      }

      if (this.form.NotaDebito.referencia != null && this.form.NotaDebito.referencia.length > 30) {
        this.alerta("El No. de Documento no puede tener más de 30 caracteres", "error")
        return
      }

      if (this.contabilidad == null) {
        //  this.getCrearCont()
      }

       /* if(this.opcPendientePagado==true){
      //el valor aplicado es diferente al valor de la factura seleccionada
        if(this.RedondeoValorCantRed(this.form.NotaDebito.valor,2)!=this.RedondeoValorCantRed(this.selectedFactura[0].valor,2)){
            this.alerta("El valor aplicado es diferente al valor de la factura seleccionada", "error")
            return
        }
       }*/

      if (this.debeConfirmarDevolucionesPendientes()) {
        EventBus.$emit("loading", false)
        this.Exec_notif({
          estado: true,
          nombre: "Tiene nota de devoluciones pendiente para este proveedor ¿Va a continuar la nota de débito sin seleccionar ninguna?",
          Exec: "ContinuarSinDevolucion",
        })
        return
      }

      this.continuarGuardadoNotaDebito()
    },

    debeConfirmarDevolucionesPendientes() {
      var esNueva = this.form.NotaDebito.notadebitoproveedoresPK.codigo == 0
      var hayPendientes = this.ListDevPend != null && this.ListDevPend.length > 0
      var ningunaSeleccionada = this.selectedDevolucion == null || this.selectedDevolucion.length == 0
      return esNueva && hayPendientes && ningunaSeleccionada
    },

    continuarSinDevolucionPendiente() {
      this.notif.estado = false
      this.continuarGuardadoNotaDebito()
    },

    cancelarSinDevolucionPendiente() {
      this.notif.estado = false
      EventBus.$emit("loading", false)
      this.ejecucion = true
    },

    continuarGuardadoNotaDebito() {
      if (this.$refs.form.validate()) {
        if (this.ejecucion == true) {
          EventBus.$emit("loading", true)
          this.ejecucion = false

          var _this = this
          setTimeout(function() {
            _this.saveCont()
          }, 1000)
        }
      } else {
        this.alerta("los campos en rojo son Requeridos", "error")
      }
    },

    saveCont() {

      this.form.NotaDebito.contabilidad = this.contabilidad
      //if (this.selectedDevolucion.length>0){
      this.form.NotaDebito.devolucionproveedorList = this.selectedDevolucion
      // }
      //
      if (this.editCuentasC && (typeof this.form.NotaDebito.contabilidad != "object" || this.form.NotaDebito.contabilidad === null)) {
        this.form.NotaDebito.contabilidad = {
          activo: true,
          borrado: false,
          comentario: "",
          contabilidadDetalleList: [],
          documento: this.form.NotaDebito.documentoproveedor.codigo,
          dsc: null,
          empresa: 0,
          entradaDiario: null,
          fecha: this.form.NotaDebito.fecha,
          id: null,
          operaciones: this.form.NotaDebito.documentoproveedor.operacion,
          referencia: "",
        }
      }

      if (typeof this.form.NotaDebito.contabilidad === "object" && this.form.NotaDebito.contabilidad !== null && this.RLisCuenta.length > 0) {
        // this.contabilidad.contabilidadDetalleList = this.RLisCuenta
        // this.form.NotaDebito.contabilidad = this.contabilidad
        this.form.NotaDebito.contabilidad.contabilidadDetalleList = this.RLisCuenta
      } else if (this.editCuentasC && typeof this.form.NotaDebito.contabilidad === "object" && this.form.NotaDebito.contabilidad !== null) {
        this.form.NotaDebito.contabilidad.contabilidadDetalleList = []
      }

      if (typeof this.form.NotaDebito.contabilidad === "object" && this.form.NotaDebito.contabilidad !== null &&
        (typeof this.form.NotaDebito.contabilidad.contabilidadDetalleList != "object" || this.form.NotaDebito.contabilidad.contabilidadDetalleList === null)) {
        this.form.NotaDebito.contabilidad.contabilidadDetalleList = []
      }

      //this.fechaNueva()
      var OBJNOta=JSON.parse(JSON.stringify(this.form.NotaDebito))
      OBJNOta.fecha=this.form.NotaDebito.fecha.trim().substr(0, 10) + "T04:00"
      OBJNOta.opcPendientePagado=this.opcPendientePagado
        //this.form.NotaDebito
      this.$axios
        .post(
          this.$hostname + this.$hName + "/notadebitoproveedores/salvar", OBJNOta,
          { headers: this.$store.getters.GetheadersAxios },
        )
        .then(res => this.alerta("Dato guardado correctamente", "bien"))
        .catch(error => {
          this.boolVerificarProveedorNcf = true
          this.alerta(error, "error")
        })

    },


    NotifMessage() {

      if (this.form.NotaDebito.notadebitoproveedoresPK.codigo != 0 && this.form.NotaDebito.notadebitoproveedoresPK.codigo != null) {
        var notif = {
          estado: true,
          nombre: "¿Seguro que desea Anular este registro?",
          Exec: "AnularDebito",
        }

        this.Exec_notif(notif)
      } else {
        this.alerta("Seleccione una Nota de Debito para Anular", "error")
      }


    },

    Exec_notif(e) {
      this.notif = JSON.parse(JSON.stringify(e))
    },


    eliminar() {
      console.log("eliminar")
    },


    anular() {
      if (this.form.NotaDebito.notadebitoproveedoresPK.codigo > 0) {
        this.contAnulado()
      } else {
        this.alerta("Seleccione una Nota de Debito para Anular", "error")
      }
    },

    contAnulado() {

      if (this.form.NotaDebito.notadebitoproveedoresPK.codigo != 0 && this.form.NotaDebito.notadebitoproveedoresPK.codigo != null) {
        if (this.$refs.form.validate()) {
          EventBus.$emit("loading", true)
          this.$axios
            .post(
              this.$hostname + this.$hName + "/notadebitoproveedores/anular", this.form.NotaDebito,
              { headers: this.$store.getters.GetheadersAxios },
            )
            .then(res => this.alerta("Dato anulado correctamente", "bien"))
            .catch(error => this.alerta(error, "error"))
        } else {
          this.alerta("Los campos en rojo son requeridos", "error")

        }
      }

    },

    imprimirList() {
      if (this.form.NotaDebito.notadebitoproveedoresPK.codigo > 0) {


        this.datosImprecion.codigo = this.form.NotaDebito.notadebitoproveedoresPK.codigo
        this.datosImprecion.documento = this.form.NotaDebito.notadebitoproveedoresPK.documento


        this.dialogimprimirList = true
      } else {
        this.alerta("Seleccione un Producto para poder imprimir", "error")
      }
    },


    DDataReporteBasico(e) {
      this.dialogimprimirList = e
    },

    OpendialogimprimirListFilt() {
      this.dialogimprimirListFilt = true
      var _this = this
      setTimeout(function() {
        _this.$refs.ModRepfil.CrearObjecto = _this.validarObjecto
      }, 300)

    },


    validarObjecto() {
      //this.datosImprecionAll.tenant=this.datosImprecion.schema=this.$store.getters.GetheadersAxios["X-TENANT-ID"]
      var where = "notadebitoproveedores.codigo > 0"
      where += ` and notadebitoproveedores.fecha>= ' ${new Date(this.datosImprecionAll.desde).toISOString().substr(0, 10)}' and notadebitoproveedores.fecha <= ' ${new Date(this.datosImprecionAll.hasta).toISOString().substr(0, 10)} ' `

      this.datosImprecionAll.documento = ""
      this.datosImprecionAll.proveedor = ""


      if (this.datosImprecionAll.documentos != null) {
        where += ` and notadebitoproveedores.documento= ${this.datosImprecionAll.documentos.codigo}`
        this.datosImprecionAll.documento = this.datosImprecionAll.documentos.descripcion
      }

      if (this.datosImprecionAll.proveedores != null) {
        where += ` and notadebitoproveedores.proveedor= ${this.datosImprecionAll.documentos.codigo}`
        this.datosImprecionAll.proveedor = this.datosImprecionAll.proveedores.descripcion
      }


      this.datosImprecionAll.where = where


      //    ic.imprimir("listado_nota_debito", parametros, "cxp");


    },


    newwnuevo() {
      this.BarraTablaDinamicaAprir = false
      this.ListDevPend = []
      this.selectedFactura = []
      this.RlistFactVent = []
      this.RlistFactVentTemp = []
      this.RLisCuenta = []
      this.editCuentasC=false
      this.form = {
        NotaDebito: {
          notadebitoproveedoresPK: { codigo: 0, documento: 0 },
          codigo: 0,
          fecha: fechaNueva(),
          moneda: null,
          proveedor: null,
          direccionEnvio: "",
          concepto: "",
          descuentoIndividual: 0,
          tasa: 0,
          documentoproveedor: null,
          ncf: "",
          valor: 0,
          itbis: 0,
          contabilidad: null,
          referencia: "",
          gasto: null,
          activada: true,
          activa: true,
        },
        RLisCuenta: [],
        TotalCuenta: {
          credito: 0,
          debito: 0,
        },
        Total: {
          valor: 0,
          pendiente: 0,
          ncr: 0,
          itbis: 0,
          balanceTotal: 0,
        },
      }
      this.RlistFactVent = []
      this.selectedFactura = []
      this.selectedDevolucion = []
      this.boolVerificarProveedorNcf = false
      this.opcPendientePagado=true
      this.ejecucion = true
      EventBus.$emit("actualizaBarraBusqueda2")
      EventBus.$emit("loading", false)
    },

    datostabla(e) {
      this.TotalCuenta = null
      this.TotalCuenta = {
        credito: 0,
        debito: 0,

      },
        this.RLisCuenta = []
      this.form.RLisCuenta = []
      this.selectedFactura = []
      this.RlistFactVent = []
      this.ListDevPend = []
      this.selectedDevolucion = []
      this.form.NotaDebito = JSON.parse(JSON.stringify(e))
      // this.form.NotaDebito.fecha = (new Date(e.fecha)).toJSON().split("T")[0]
      this.form.NotaDebito.fecha = e.nuevaFecha
      this.ListDevPend = e.devolucionproveedorList
      var _this = this
      setTimeout(function() {
        _this.selectedDevolucion = _this.ListDevPend
        //    _this.getCrearCont()
      }, 500)


      if (e.hasOwnProperty("concepto") && e.concepto != null && e.concepto.trim().length > 0) {
        this.form.NotaDebito.concepto = e.concepto
      } else {
        this.form.NotaDebito.concepto = ". "
      }


      this.reAsignar(e)
      this.acti_tb_data = false
    },


    changeProveedor(e) {


      if (e != null && typeof e === "object") {
      this.findDetalle()
        this.findDevolucion()
      } else {
        this.ListDevPend = []
      }
//
      // e.fechaVencimiento!=null && typeof e.fechaVencimiento==='object'

    },

    cargarProveedor() {

      this.$axios.get(this.$hostname + this.$hName + "/proveedores/findallbyDesc/25/0/*", { headers: this.$store.getters.GetheadersAxios })
        .then(res => (this.Rproveedor = res.data))

    },

    SelctCbProveedor() {
      var _this = this
      setTimeout(function() {
        if (_this.form.NotaDebito.proveedor == null) {
          _this.form.NotaDebito.proveedor = ""
        }

        if (!_this.form.NotaDebito.proveedor.hasOwnProperty("codigo")) {
          _this.form.NotaDebito.proveedor = ""
          _this.form.NotaDebito.proveedor = null
          //  _this.alerta("Seleccione un cliente", "error");
          return
        }

       // _this.findDetalle()
        _this.findDevolucion()
        _this.VerificarProveedorNcf()

      }, 300)
    },

    CbFilProveedor(e) {
      if (e.target.value.length >= 0) {
        this.$axios
          .get(
            this.$hostname +
            this.$hName +
            "/proveedores/findallbyDesc/25/0/" + (e.target.value === "" ? "A" : e.target.value),
            { headers: this.$store.getters.GetheadersAxios },
          )
          .then(res => (this.Rproveedor = res.data))
      }

    },


    SelctCbMoneda() {

      if (this.form.NotaDebito.moneda == null) {

        this.form.NotaDebito.moneda = ""
      }

      if (this.form.NotaDebito.moneda.codigo == undefined) {

        this.alerta("Seleccione una moneda", "error")
        this.form.NotaDebito.moneda = ""
        return

      }

    },

    cargarMoneda() {

      this.$axios.get(this.$hostname + this.$hName + "/monedas/findallActivos/", { headers: this.$store.getters.GetheadersAxios })
        .then(res => (this.Rmoneda = res.data))

    },


    SelctCbProveedoresFiltro() {
      if (this.Modallfiltro.proveedores == null) {
        this.Modallfiltro.proveedores = ""
      }
      if (this.Modallfiltro.proveedores.codigo == undefined) {
        this.alerta("Seleccione un proveedores", "error")
        this.Modallfiltro.proveedores = ""
        return
      }
    },

    SelctCbDocumentoFiltro() {
      if (this.Modallfiltro.documento == null) {
        this.Modallfiltro.documento = ""
      }
      if (this.Modallfiltro.documento.codigo == undefined) {
        this.alerta("Seleccione un documento", "error")
        this.Modallfiltro.documento = ""
        return
      }
    },

    ReportBlurDesde() {
      if (this.datosImprecionAll.desde.toString().length == 0) {
        this.datosImprecionAll.desde = this.fechaNueva()
      }
    },
    ReportBlurHasta() {
      if (this.datosImprecionAll.hasta.toString().length == 0) {
        this.datosImprecionAll.hasta = this.fechaNueva()
      }
    },

    SelctCbReportDocumento() {
      if (this.datosImprecionAll.documentos == null) {
        this.datosImprecionAll.documentos = ""
      }
      if (this.datosImprecionAll.documentos.codigo == undefined) {
        this.alerta("Seleccione un documento", "error")
        this.datosImprecionAll.documentos = ""
        return
      }
    },


    SelctCbReportProveedores() {
      if (this.datosImprecionAll.proveedores == null) {
        this.datosImprecionAll.proveedores = ""
      }
      if (this.datosImprecionAll.proveedores.codigo == undefined) {
        this.alerta("Seleccione un proveedores", "error")
        this.datosImprecionAll.proveedores = ""
        return
      }
    },


    abrirTabla() {
      this.BarraTablaDinamicaAprir = !this.BarraTablaDinamicaAprir
      if (this.BarraTablaDinamicaAprir == true) {
        this.Limpiarfiltro()
      }
    },

    actualiza_tb_ver() {

      this.acti_tb_data = !this.acti_tb_data
      this.Limpiarfiltro()

    },

    Limpiarfiltro() {
      var Pg = {
        itemsLength: this.TbPaginator.itemsLength,
        itemsPerPage: this.TbPaginator.itemsPerPage,
        page: 1,
        pageCount: 1,
        pageStart: 0,
        pageStop: this.TbPaginator.itemsPerPage,
      }

      this.Modallfiltro = {
        proveedores: null,
        codigo: null,
        documento: null,
        Desde: null,
        Hasta: null,
      }

      this.ListItems = []
      this.TbTotalItem = 0
      this.TbPaginator = JSON.parse(JSON.stringify(Pg))
      this.CargarListTb()
      this.dialogFiltros = false

    },

    BuscarFiltros() {
      var Pg = {
        itemsLength: this.TbPaginator.itemsLength,
        itemsPerPage: this.TbPaginator.itemsPerPage,
        page: 1,
        pageCount: 1,
        pageStart: 0,
        pageStop: this.TbPaginator.itemsPerPage,
      }

      if (this.Modallfiltro.codigo != null && this.Modallfiltro.codigo.toString().length == 0) {
        this.Modallfiltro.codigo = null
      }

      this.TbPaginator = JSON.parse(JSON.stringify(Pg))
      this.CargarListTb()
      this.dialogFiltros = false

    },


    cargarPaginacionAll(e) {

      if (e.itemsPerPage == -1) {
        e.itemsPerPage = 15
      }
      this.CargarPaginacion(e, this.Modallfiltro.codigo)
    },

    CargarPaginacion(e, s) {

      this.Modallfiltro.codigo = JSON.parse(JSON.stringify(s))

      if (e.itemsPerPage == -1) {
        e.itemsPerPage = 15
      }
      //var pg =
      this.TbPaginator = JSON.parse(JSON.stringify(e))
      this.CargarListTb()

    },

    CargarListTb() {

      var prove = null
      var doc = null
      if (this.Modallfiltro.proveedores != null) {
        prove = this.Modallfiltro.proveedores.codigo
      }
      if (this.Modallfiltro.documento != null) {
        doc = this.Modallfiltro.documento.codigo
      }
      var obj = this.TbPaginator.itemsPerPage + "/" + this.TbPaginator.pageStart + "/" + this.Modallfiltro.codigo + "/" + prove + "/" + doc + "/" + this.Modallfiltro.Desde + "/" + this.Modallfiltro.Hasta
      this.$axios.get(this.$hostname + this.$hName + "/notadebitoproveedores/findListNotaDebitoPlus/" + obj, { headers: this.$store.getters.GetheadersAxios })
        .then(res => {
          this.ListItems = res.data.ListItems, this.TbTotalItem = res.data.TbTotalItem
        })
    },


    VerificarProveedorNcf() {


      if (this.form.NotaDebito.proveedor == null) {
        this.boolVerificarProveedorNcf = false
        return
      }

      if (this.form.NotaDebito.ncf == null || this.form.NotaDebito.ncf.trim().length == 0) {
        this.boolVerificarProveedorNcf = false
        return
      }


      var obj = {
        codpro: this.form.NotaDebito.proveedor.codigo,
        ncf: this.form.NotaDebito.ncf.trim(),
        sec: this.form.NotaDebito.notadebitoproveedoresPK.codigo,
        doc: this.form.NotaDebito.notadebitoproveedoresPK.documento,

      }

      return this.$axios.post(this.$hostname + this.$hName + "/notadebitoproveedores/VerificarProveedorNcf", obj,
        { headers: this.$store.getters.GetheadersAxios },
      )
        .then(res => {
          if (res.data == true) {
            this.alerta("NOTA: EL NCF ya fue registrado con el proveedor seleccionado", "error")
            this.boolVerificarProveedorNcf = true
            return
          } else {
            this.boolVerificarProveedorNcf = false
          }

        })
        .catch(error => this.alerta(error, "error"))


      /*this.$axios.post(this.$hostname + this.$hName + '/VerificarProveedorNcf/'+ obj+"/", { headers: this.$store.getters.GetheadersAxios })
        .then(res => { 
      

        })*/

    },


    loaderTablaCargar() {
      this.loaderTabla = true
      var _this = this
      setTimeout(function() {
        _this.loaderTabla = false
      }, 900)
    },

buscarFacKeyEnter(){
  var Pg = {
        itemsLength: this.paginatorFactura.itemsLength,
        itemsPerPage: this.paginatorFactura.itemsPerPage,
        page: 1,
        pageCount: 1,
        pageStart: 0,
        pageStop: this.paginatorFactura.itemsPerPage,
      }

//this.getFacVenta()
  // this.paginatorFactura = JSON.parse(JSON.stringify(Pg))
this.cargarPaginacionFactura(Pg)
},
changeRadioPenPag(){
this.selectedFactura=[]
  var _this = this
      setTimeout(function() {
        _this.findDetalle()
        _this.selectedDevolucion=[]
        _this.ListDevPend=[]
        //    _this.getCrearCont()
      }, 500)

},

modoPendientePago(){

var PER_NOTADEBITO_Factsalda =this.$store.getters.GetConfiguracionGeneral.configCxp.permitirNotasdebitoFactsalda
//var ProveeExtr= (this.form.NotaDebito.proveedor != null && this.form.NotaDebito.proveedor.hasOwnProperty("proveedorExtranjero") && this.form.NotaDebito.proveedor.proveedorExtranjero==true)
console.log('NEMsdfsdfsdf-length-->',this.RlistFactVent.length)
console.log('NEM--->',PER_NOTADEBITO_Factsalda)
console.log('NEM-sdf-->',this.form.NotaDebito.proveedor)
if(PER_NOTADEBITO_Factsalda==true){
return this.RlistFactVent.length>0
}else{
  console.log('INF:-->',this.form.NotaDebito.proveedor != null && this.form.NotaDebito.proveedor.balanceproveedor.balance > 0)
 return this.form.NotaDebito.proveedor != null && this.form.NotaDebito.proveedor.balanceproveedor.balance > 0
}

},

    alerta(e, l) {
      if (l == "bien") {
        (this.aalert.estado = true),
          (this.aalert.color = "success"),
          (this.aalert.nombre = e)

        this.newwnuevo()
      }

      if (l == "error") {
        (this.aalert.estado = true),
          (this.aalert.color = "error"),
          (this.aalert.nombre = e)
        EventBus.$emit("loading", false)
        this.ejecucion = true
      }
    },


    async filtro() {
      await this.$axios
        .get(
          this.$hostname + this.$hName + "/notadebitoproveedores/findall",
          { headers: this.$store.getters.GetheadersAxios },
        )
        .then(res => {
          this.list = res.data
        })
    },


    abrirTabla2() {
      this.BarraSecundariaAprir = !this.BarraSecundariaAprir
    },
    // abrirTabla2() {
    //   return !this.abrirTablaDinamica
    // }
  },


  computed: {

    ActDescBtn() {

      if (this.form.NotaDebito.notadebitoproveedoresPK.codigo > 0) {
        if (this.form.NotaDebito.activa) {

          this.EstadoBtn = {
            BarraTablaDinamicaAprir: true,
            nuevo: true,
            guardar: true,
            eliminar: false,
            anular: true,
            imprimir: true,
            vercuenta: true,
            guardartemporal: false,
            restaurartemporal: false,
            importarDato: false,
            cargarProducto: false,
            ImprimirproductoInv: false,
          }


          if (this.form.NotaDebito.activa == false) {
            this.EstadoBtn.anular = false
          }
        } else {
          this.EstadoBtn = {
            BarraTablaDinamicaAprir: true,
            nuevo: true,
            guardar: false,
            eliminar: false,
            anular: false,
            imprimir: true,
            vercuenta: false,
            guardartemporal: false,
            restaurartemporal: false,
            importarDato: false,
            cargarProducto: false,
            ImprimirproductoInv: false,
          }


          if (this.form.NotaDebito.activa == false) {
            this.EstadoBtn.anular = false
          }
        }


      }


      if (this.form.NotaDebito.notadebitoproveedoresPK.codigo <= 0) {
        this.EstadoBtn = {
          BarraTablaDinamicaAprir: true,
          nuevo: true,
          guardar: true,
          eliminar: false,
          anular: false,
          imprimir: false,
          vercuenta: true,
          guardartemporal: false,
          restaurartemporal: false,
          importarDato: false,
          cargarProducto: false,
          ImprimirproductoInv: false,
        }

      }


      this.windowSize = JSON.parse(JSON.stringify(this.$store.getters.GetwindowSize))


    },

  },


}
</script>

<style>

</style>
